import React from 'react';
import { mapEmbedSrc } from '../data/locations';
import '../styles/LocationMap.css';

/*
 * "Where You'll Be" band — sits between the property hero and the dates
 * section on both location pages. Renders nothing until the location has a
 * mapsUrl, so an unfilled entry in src/data/locations.js is a no-op rather
 * than a dead button.
 *
 * The map is a keyless Google embed, lazy-loaded so it costs nothing until the
 * band scrolls into view. Without an embed source the band still renders, just
 * as the single centred column it was before.
 */
export default function LocationMap({ location }) {
  if (!location || !location.mapsUrl) return null;

  const { locality, region, blurb, mapsUrl, name } = location;
  const embedSrc = mapEmbedSrc(location);

  return (
    <section className={`mm-map-band${embedSrc ? ' has-map' : ''}`}>
      <div className="mm-map-inner">
        <div className="mm-map-text">
          <h2 className="mm-map-heading">Where You'll Be</h2>
          <div className="mm-map-divider"><span></span><i>✦</i><span></span></div>
          <p className="mm-map-address">{locality}, {region}</p>
          {blurb && <p className="mm-map-blurb">{blurb}</p>}
          <a
            className="mm-map-btn"
            href={mapsUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
              <circle cx="12" cy="10" r="3" />
            </svg>
            View on Google Maps
          </a>
        </div>

        {embedSrc && (
          <div className="mm-map-frame">
            <iframe
              src={embedSrc}
              title={`Map showing ${name}`}
              loading="lazy"
              allowFullScreen
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        )}
      </div>
    </section>
  );
}
